import React from "react";
import clsx from "clsx";
import { Link, useLocation } from "react-router";
import AdInContent from "~/components/ads/AdInContent";
import { getLocale } from "~/i18n";

interface Props {
    className?: string,
    children: React.ReactNode,
}

const CalculatorLayout: React.FC<Props> = (
    {
        className = null,
        children,
    }
) => {
  const locale = getLocale(useLocation().pathname);

  return (
    <div className={clsx(className)}>
      {children}
      <div className="py-10">

      { locale === "ru"
        ? <AdInContent type="yandex" adId="R-A-7013740-2" />
        : <AdInContent type="google" adId="2142145936" />
      }
      </div>

    </div>
  );
};

export default CalculatorLayout;
